import { HeadlineType } from '../../user/login/Form';
import * as React from 'react';
import * as H from 'history';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { IAppOnlyStore } from 'stores/AllStores';
import { User } from 'stores/User';
import { LoginForm } from 'routes/user/login/Form';

// Styles
const s = require('./PageForbidden.css');

// Props
interface IAppForbidden extends IAppOnlyStore {
  readonly user: User;
  readonly history: H.History;
  readonly location: H.Location;
}

// Component
@observer
export class PageForbidden extends React.Component<IAppForbidden, {}> {
  constructor() {
    super();
  }

  public render() {
    return (
      <div className={s.pageForbidden}>
        <LoginForm
          headline={
            this.props.user.isLoggedIn
              ? 'Page not allowed — login as user with appropriate permissions'
              : 'Welcome to Spyka CRM — login with your credentials'
          }
          headlineType={
            this.props.user.isLoggedIn
              ? HeadlineType.Important
              : HeadlineType.Normal
          }
          showBack={this.props.user.isLoggedIn}
          location={this.props.location}
          history={this.props.history}
        />
      </div>
    );
  }
}

export default PageForbidden;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/errors/PageForbidden/PageForbidden.tsx